import React, { useEffect, useRef, useState } from "react";
import styles from "./CustomAgent.module.css";
import CustomAutomationsWrapper from "../../../../CustomAutomationsWrapper/CustomAutomationsWrapper";
import { ReactComponent as GreenCheck } from "../../../../../assets/GreenCheck.svg";
import { ReactComponent as CampanaBordes } from "../../../../../assets/CampanaBordes.svg";
import OptionsSwitchComponent from "../../../../OptionsSwichComponent/OptionsSwitchComponent";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { getAgents, getAgentsByIds } from "../../../../../../../actions/agents";


import { ReactComponent as IconOpenAI } from "../../../../../assets/icon-openai.svg";
import { ReactComponent as IconAutomate } from "../../../../../assets/icon-automate.svg";
import { ReactComponent as IconVerify } from "../../../../../assets/icon-verify.svg";
import { ReactComponent as IconStar } from "../../../../../assets/icon-star.svg";
import { ReactComponent as IconAttach } from "../../../../../assets/icon-attach.svg";
import { ReactComponent as IconAgent } from "../../../../../assets/agent.svg";
import { ReactComponent as IconSearch } from "../../../../../assets/searchGray.svg";

import { formatAgoDate } from "../../../../../../../utils/agoDateUtil";


const CustomAgent = ({
  configuration = {  },
  handleConfigurationChange,
  icon,
  action,
  emailConnections = [],
  selectedEmailConnection,
  setSelectedEmailConnection,
  placeholder,
  headerStyle = {},
  setShowCategory,
  setShowGmailModalAddConnection,
}) => {
  const [t] = useTranslation(["AutomatesComponent","Preview"]);
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState("");
  const [filteredAgents, setFilteredAgents] = useState([]);
  const [selectedAgents, setSelectedAgents] = useState([]);
  const [showSearchResults, setShowSearchResults] = useState(false);

  const [showContent, setShowContent] = useState({
    info1: false,
    info2: false,
    info3: false,
    info4: false,
    info5: false,
    info6: false,
    info7: false,
    info8: false,
    info9: false,
  });

  const handleSetShowContent = (content) => {
    setShowContent({
      ...showContent,
      [content]: !showContent[content],
    });
  };

  const {
    agents,
    loading: loadingAgent,
    error,
    selectedAgentSlice,
  } = useSelector((state) => state.agents);


  useEffect(() => {
    dispatch(getAgents());
  }, []);
  
  
  useEffect(() => {
    if(configuration?._id && configuration?.agents && configuration.agents.length > 0){
      dispatch(getAgentsByIds(configuration.agents));
    }
  }, [configuration._id])

  useEffect(() => {
    if (agents.success) {
      setFilteredAgents(agents.agents);
      if (configuration?.agents && Array.isArray(configuration.agents)) {
        const initialSelectedAgents = agents.agents.filter(agent => 
          configuration.agents.includes(agent._id)
        );
        setSelectedAgents(initialSelectedAgents);
      }
      setShowSearchResults(true);
    }
  }, [agents]);

  useEffect(() => {
    if (searchValue) {
      const filtered = agents.agents?.filter(agent =>
        agent.name.toLowerCase().includes(searchValue.toLowerCase()) &&
        !selectedAgents.some(selected => selected._id === agent._id)
      );
      setFilteredAgents(filtered);
      setShowSearchResults(true);
    } else {
      const filtered = agents.agents?.filter(agent =>
        !selectedAgents.some(selected => selected._id === agent._id)
      );
      setFilteredAgents(filtered);
    }
  }, [searchValue, agents, selectedAgents]);

  const handleAgentSelect = (agent) => {
    const isSelected = selectedAgents.some(selected => selected._id === agent._id);
    let newSelectedAgents;
    
    if (isSelected) {
      newSelectedAgents = selectedAgents.filter(selected => selected._id !== agent._id);
    } else {
      newSelectedAgents = [...selectedAgents, agent];
    }
    
    setSelectedAgents(newSelectedAgents);
    
    const agentIds = newSelectedAgents.map(agent => agent._id);
    handleConfigurationChange('agents', agentIds);
  };

  return (
    <CustomAutomationsWrapper
      Icon={<IconAgent />}
      showContent={showContent.info1}
      className={styles.hiddenMobile}
    >
      <div
        className={styles.infoContainerWrapper}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {showContent.info1 && <GreenCheck />}
          <div className={styles.infoContainer}>
            <div>
              Personaliza el orquestador
            </div>
            <span>
              Realiza una acción específica en tus agentes.
            </span>
          </div>
        </div>
        <OptionsSwitchComponent
          border={"none"}
          marginLeft={"auto"}
          isChecked={showContent.info1}
          setIsChecked={(value) => {
            handleSetShowContent("info1");
          }}
        />
      </div>

      {showContent.info1 && (
        <div className={styles.containerAgents}>
          <div className={styles.searchContainer}>
            <IconSearch />
            <input
              type="text"
              placeholder="Buscar agente"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
            <div className={styles.searchContainerShortcuts}>
              K
            </div>
          </div>
          {(showSearchResults && filteredAgents?.length === 0) && (
            <div className={styles.noResultsContainer}>
              <span>
                {t("noResults")}
              </span>
              <p>
                {t("noResultsDescription")}
              </p>
            </div>
          )}
          <ul className={styles.containerListAgents}>
            {selectedAgents?.map((item, index) => (
              <AgentItem 
                key={index} 
                agent={item} 
                onSelect={handleAgentSelect}
                isSelected={true}
              />
            ))}
          </ul>
          {showSearchResults && (
            <ul className={styles.searchContainerList}>
              {filteredAgents?.map((item, index) => (
                <AgentItem 
                  key={index} 
                  agent={item} 
                  onSelect={handleAgentSelect}
                  isSelected={selectedAgents.some(selected => selected._id === item._id)}
                />
              ))}
            </ul>
          )}
        </div>
      )}
    </CustomAutomationsWrapper>
  );
};

export default CustomAgent;



const AgentItem = ({ agent, onSelect, isSelected }) => {
  const [t] = useTranslation("AutomatesComponent");
  const navigate = useNavigate();

  const openAgentModal = (agent) => {
    navigate(`/admin/agent/${agent._id}`)
  }

  return (
    <li
      className={styles.agentItem}
      onClick={() => openAgentModal(agent)}
    >
      <input 
        type="checkbox" 
        checked={isSelected}
        onChange={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onSelect(agent);
        }}
      />
      <div className={styles.agentItemIcon}>
        <IconAgent />
      </div>
      <div className={styles.agentItemInfo}>
        <p>
          {agent.name}
        </p>
        <span>
          Descripcion

        </span>
      </div>
      <div className={styles.agentItemActions}>
        <div className={styles.agentItemActionsInfo}>
          FacturaGPT
          <IconStar />
          <IconVerify />
        </div>
        <div className={styles.agentItemActionsItem}>
          <div className={styles.agentItemActionsItemLabel}>
            <IconAttach />
            5
          </div>
          <span>
            {formatAgoDate({createdAt: agent.createdAt,t})}
          </span>
        </div>
      </div>
    </li>
  );
};